.framedContent {
  background-color: white;
  border: none;
  height: calc(100vh - 36px);
  width: 100%;
}

.hiddenFrame {
  display: none;
}
